const styles = {
    floatingActionButton: {
      margin: 0,
      top: 'auto',
      right: 20,
      bottom: 20,
      left: 'auto',
      position: 'fixed',
    },
    iconButton: {
      margin: 12,
    },
    toolButton: {
      top: 5
    },
    container: {
      height: 'calc(100% - 64px)',
      width: '100%'
    },
    menuContainer:{
        float: 'right',
        display: 'inline'
    },
    searchFormModalWidth:{
      width: '80%',
      minHeight: 400,
      maxWidth: 'none',
    },
    searchButton: {
      marginLeft: 5
    },
    menuItem: {
      color: '#666',
      fontSize: 14
    },
    imageIcon:{
      backgroundColor: 'transparent',
      borderRadius: 0
  }
};

export default styles;


// WEBPACK FOOTER //
// ./src/containers/search/styles/searchPageStyles.js